import Quill from 'quill';

export const QUILL_CSS_PROPERTIES = [
    'fontFamily', 'color', 'backgroundColor', 'fontSize', 'lineHeight', 'textAlign',
    'fontWeight', 'fontStyle', 'marginLeft', 'text-indent'
];
export const NON_INHERITED_QUILL_CSS_PROPERTIES = [ 'margin-left', 'text-indent' ];
export const NON_MSO_LIST_CSS_PROPERTIES = NON_INHERITED_QUILL_CSS_PROPERTIES;

/** HACK this fixes an issue where package builds think that these are node packages to import, rather than quill extensions */
const quimport = Quill.import.bind(Quill);

export const IMAGE_FILE_TYPE_REGEX = /image\/(gif|jpe?g|png)/;
export const MAX_FILE_SIZE_BYTES = 1000000;
export const FONT_FAMILY_WHITE_LIST = [
    'Arial, Helvetica, sans-serif',
    'Helvetica, Arial, sans-serif',
    'Courier New, Courier, monospace',
    'Georgia, serif',
    'Trebuchet MS, Helvetica, sans-serif',
    'Comic Sans MS, Helvetica, sans-serif',
    'Lucida Sans Unicode, Lucida Grande, sans-serif',
    'Tahoma, Geneva, sans-serif',
    'Times New Roman, Times, serif',
    'Verdana, Geneva, sans-serif'
];

export const FONT_SIZE_WHITE_LIST: number[] = [8, 9, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];

export const LINE_HEIGHT_DISPLAY_TO_ENUM_VALUE_MAP: Map<number, number> =  new Map<number, number>([
    [1, 1.3],
    [1.5, 1.95],
    [2, 2.6],
    [2.5, 3.25],
    [3, 3.9]
]);

export const PASTED_INHERITED_ATTRIBUTES: string[] = ['src', 'href', 'dir', 'classList'];

export const WORD_INHERITED_CSS_STYLES_LIST = ['font-size', 'font-family', 'color'];
